export const translations = {
  it: {
    nav: {
      comeFunziona: 'Come Funziona',
      menu: 'Il Menù',
      prezzo: 'Il Prezzo',
      doveSiamo: 'Dove Siamo',
      chiSiamo: 'Chi Siamo',
    },
    hero: {
      badge: 'CUCINA ITALIANA AUTENTICA',
      title: "L'unico buffet a peso a Bologna",
      subtitle: 'Libero, Autentico, Veloce.',
      description: 'Cucina italiana da filiera controllata. Componi il tuo piatto, metti sulla bilancia e paghi solo quello che scegli, al tuo ritmo.',
      priceLabel: '/etto',
      scrollText: 'Scopri di più',
    },
    stats: {
      pricePerHecto: "ALL'ETTO",
      minConsumption: 'CONSUMAZIONE',
      freshDishes: 'PIATTI FRESCHI',
      italianRecipes: 'RICETTE ITALIANE',
    },
    concept: {
      overline: 'IL NOSTRO CONCEPT',
      title: 'Dove la Libertà Incontra il Gusto',
      text1: "Se ti stai chiedendo dove mangiare a Bologna per vivere un\u2019esperienza diversa dal solito, benvenuto nel nostro bistrot contemporaneo. Qui il cliente è il vero protagonista: puoi comporre il tuo piatto ideale attingendo da un ricco buffet gourmet che celebra i sapori della tradizione regionale e nazionale.",
      text2: "Siamo il primo ristorante a peso a Bologna pensato per chi ama la flessibilità: scegli solo ciò che desideri e paghi esattamente per quello che consumi.",
      text3: "Ogni ricetta è frutto di una ricerca costante per garantirti un ristorante a filiera controllata, dove la stagionalità e l'eccellenza della cucina italiana sono sempre al primo posto. Non è solo questione di mangiare sano, ma di riscoprire il piacere consapevole di un pasto autentico e quotidiano.",
      highlight: "È un format che celebra la semplicità — la libertà di scegliere, la fiducia nel cibo, la gioia del gusto condiviso.",
    },
    vision: {
      overline: 'LA NOSTRA VISION',
      title: 'Ispirare un Nuovo Modo di Mangiare',
      text: "Diventare un punto di riferimento per chi cerca una pausa pranzo a Bologna che non scenda a compromessi tra velocità e benessere. Vogliamo ispirare un nuovo modo di mangiare italiano \u2014 libero, consapevole e gioioso \u2014 dove ogni scelta racconta un modo semplice ma non banale, rispetto per la terra e piacere per la vita quotidiana.",
      values: [
        { title: 'Libertà', desc: 'Scegli tu cosa e quanto mangiare' },
        { title: 'Autenticità', desc: 'Ricette della tradizione italiana' },
        { title: 'Consapevolezza', desc: 'Ingredienti freschi e trasparenti' },
      ],
    },
    mission: {
      overline: 'LA NOSTRA MISSION',
      title: 'Coltivare il Piacere della Scelta',
      text1: "Vogliamo restituire al cibo il suo potere più profondo: nutrire e emozionare senza sovrastrutture.",
      text2: "Il nostro bistrot/casa è uno spazio libero, dove ognuno compone la propria esperienza come un gesto d'amore verso la vita e se stessi.",
      text3: "Ogni piatto è un incontro tra la tradizione italiana e la libertà personale, un atto di curiosità ed esplorazione.",
      highlight: "Crediamo che la felicità passi anche da qui \u2014 da un pasto semplice, fatto bene, condiviso con chi si ama o con se stessi. Tutti i giorni.",
    },
    howItWorks: {
      overline: 'IL NOSTRO SISTEMA',
      title: 'Come Funziona',
      steps: [
        {
          title: 'Occupi il Posto',
          subtitle: 'CON LA PLACCHETTA',
          description: 'Occupa il tuo tavolo con la placchetta. La nostra atmosfera calda ti aspetta.',
        },
        {
          title: 'Crei il Tuo Mix',
          subtitle: 'AL BUFFET',
          description: 'Vai al buffet e componi liberamente il tuo piatto con le nostre ricette italiane.',
        },
        {
          title: 'Pesi in Cassa',
          subtitle: 'AL BANCONE',
          description: "Porta il piatto alla cassa: lo pesiamo per te. Solo 2,20\u20AC all'etto.",
        },
        {
          title: 'Gusti la Libertà',
          subtitle: 'GODITI IL PASTO',
          description: "Siediti, mangia e goditi l'autentica cucina italiana. Puoi tornare quante volte vuoi!",
        },
      ],
    },
    moments: {
      lunch: {
        title: 'Pausa Pranzo a Bologna? Rapida, sana e su misura per te.',
        description: "Dimentica i tempi lunghi del servizio al tavolo. Da Lola la Libertà gestisci tu la tua pausa: prendi il vassoio, scegli tra decine di ricette fresche (lasagne, verdure di stagione e secondi sfiziosi), pesi e ti siedi. Tutta la qualità di un vero ristorante italiano, con la fluidità e la rapidità che ti servono per goderti il pasto e tornare al lavoro soddisfatto.",
      },
    },
    menu: {
      overline: 'RICETTE TRADIZIONALI',
      title: 'Esempi di Cosa Cuciniamo',
      subtitle: 'Ogni giorno prepariamo oltre 20 piatti freschi con ingredienti selezionati.',
      tabs: {
        primi: 'Primi Piatti',
        secondi: 'Secondi Piatti',
        contorni: 'Contorni',
        dolci: 'Dolci',
      },
      items: {
        primi: [
          'Lasagne alla Bolognese',
          'Tagliatelle al ragù',
          'Tortellini in brodo',
          'Risotto alla parmigiana',
          'Pasta e fagioli',
          'Cannelloni ricotta e spinaci',
        ],
        secondi: [
          'Pollo arrosto alle erbe',
          'Cotoletta alla milanese',
          'Polpette al sugo',
          'Arrosto di maiale',
          'Scaloppine al limone',
          'Baccalà alla vicentina',
        ],
        contorni: [
          'Patate arrosto',
          'Verdure grigliate',
          'Insalata mista',
          'Spinaci saltati',
          'Caponata siciliana',
          'Fagiolini al pomodoro',
        ],
        dolci: [
          'Tiramisù della casa',
          'Panna cotta',
          'Torta della nonna',
          'Crema catalana',
          'Crostata di frutta',
          'Cannoli siciliani',
        ],
      },
    },
    pricing: {
      overline: 'TRASPARENZA TOTALE',
      title: 'Un Prezzo,',
      titleItalic: 'Nessuna Sorpresa',
      description: "Da noi paghi esattamente quello che mangi. Solo il peso del tuo piatto moltiplicato per 2,20\u20AC all'etto.",
      card: {
        label: 'PREZZO UNICO',
        unit: "all'etto",
        min: '',
        exampleTitle: 'ESEMPIO DI PASTO',
        example: {
          primo: 'Primo piatto (200g)',
          secondo: 'Secondo (150g)',
          contorno: 'Contorno (100g)',
          total: 'Totale',
        },
      },
      features: [
        { title: 'Coperto Gratuito', desc: 'Nessun costo per il servizio' },
        { title: 'Acqua Gratuita', desc: 'Puoi prenderne quanta ne vuoi' },
        { title: 'Porzioni Libere', desc: 'Prendi quanto vuoi, torni quante volte vuoi' },
      ],
    },
    location: {
      overline: 'VIENI A TROVARCI',
      title: 'Dove Siamo',
      address: 'Via Jacopo della Quercia 2/2D',
      city: '40128 Bologna (BO)',
      openMaps: 'Apri su Google Maps',
      info: {
        hours: {
          title: 'Orari',
          weekdays: 'Lunedì - Venerdì',
          lunch: '12:00 - 15:00',
        },
        address: {
          title: 'Indirizzo',
        },
        parking: {
          title: 'Parcheggio',
          line1: 'Disponibile con strisce blu',
          line2: 'Parcheggio a pagamento',
        },
        price: {
          title: 'Prezzo',
          line1: "2,20\u20AC all'etto",
          line2: 'Coperto gratuito',
          line3: 'Acqua gratuita',
        },
      },
    },
    footer: {
      tagline: 'La libertà incontra il gusto.',
      description: 'Il primo buffet a peso di Bologna. Cucina italiana autentica, ingredienti freschi, prezzi trasparenti.',
      navigation: 'Navigazione',
      contact: 'Contatti',
      social: 'Social',
      legal: 'Legale',
      privacy: 'Privacy Policy',
      terms: 'Termini e Condizioni',
      rights: 'Tutti i diritti riservati.',
    },
    booking: {
      button: 'Prenota qui!',
    },
    // Page-specific translations
    home: {
      explore: {
        title: 'Esplora Lola la Libertà',
      },
      sections: [
        { title: 'Chi Siamo', desc: 'Scopri la nostra filosofia e il concept del bistrot', discoverMore: 'Scopri di più' },
        { title: 'Come Funziona', desc: 'Il nostro sistema unico in 4 semplici passi', discoverMore: 'Scopri di più' },
        { title: 'Il Menù', desc: 'Scopri i nostri piatti della tradizione italiana', discoverMore: 'Scopri di più' },
        { title: 'Il Prezzo', desc: "Trasparenza totale: 2,20\u20AC all'etto", discoverMore: 'Scopri di più' },
        { title: 'Dove Siamo', desc: 'Vieni a trovarci nel cuore di Bologna', discoverMore: 'Scopri di più' },
        { title: 'News', desc: 'Eventi, novità e promozioni', discoverMore: 'Scopri di più' },
      ],
      quickInfo: [
        'Via Jacopo della Quercia 2/2D, Bologna',
        'Lun-Ven: 12:00-15:00',
        "2,20\u20AC all'etto",
        '20+ piatti freschi ogni giorno',
      ],
    },
    chiSiamoPage: {
      hero: {
        title: 'Chi Siamo \u2013 Lola la Libertà, il tuo Bistrot Contemporaneo a Bologna',
        subtitle: 'Dove la qualità si sposa con la libertà della scelta.',
      },
      values: {
        title: 'I Nostri Valori',
        items: [
          { title: 'Libertà', desc: 'Scegli tu cosa e quanto mangiare, senza vincoli' },
          { title: 'Qualità', desc: 'Ingredienti freschi da filiere controllate' },
          { title: 'Convivialità', desc: 'Un luogo dove condividere il piacere del cibo' },
          { title: 'Autenticità', desc: 'Ricette della tradizione italiana' },
        ],
      },
    },
    comeFunzionaPage: {
      hero: {
        title: 'Come Funziona',
        subtitle: 'Il nostro sistema unico in 4 semplici passi',
      },
      whyChoose: {
        title: 'Perché Scegliere Lola',
      },
      features: [
        { title: 'Veloce', desc: 'Pausa pranzo in 30 minuti, senza attese' },
        { title: 'Trasparente', desc: 'Paghi solo quello che mangi, a peso' },
        { title: 'Varietà', desc: 'Oltre 20 piatti freschi ogni giorno' },
        { title: 'Qualità', desc: 'Ingredienti selezionati da filiere italiane' },
        { title: 'Flessibile', desc: 'Torna al buffet quante volte vuoi' },
        { title: 'Comodo', desc: 'Nel cuore di Bologna, facile da raggiungere' },
      ],
    },
    menuPage: {
      hero: {
        title: 'Il Menù',
        subtitle: 'Ricette della tradizione bolognese e italiana',
      },
      intro: 'Ogni giorno prepariamo oltre <strong>20 piatti freschi</strong> con ingredienti selezionati da filiere controllate. Dalle lasagne alla bolognese ai tortellini in brodo, dai secondi di carne alle verdure di stagione: componi il tuo piatto come preferisci.',
      gallery: {
        title: 'I Nostri Piatti',
      },
      seasonalNote: 'Il menù varia ogni giorno in base alla stagionalità',
    },
    prezzoPage: {
      hero: {
        title: 'Il Prezzo',
        subtitle: 'Trasparenza totale, nessuna sorpresa',
      },
      howPricing: {
        title: 'Come Funziona il Prezzo',
        items: [
          { title: "2,20\u20AC/etto", desc: 'Il cibo del buffet è pesato e pagato a peso. Prendi quello che vuoi, paghi solo quello che mangi.' },
          { title: '0,50\u20AC coperto', desc: 'Il coperto include tovaglioli, posate e servizio al tavolo. Prezzo fisso per tutti.' },
          { title: '0,50\u20AC acqua', desc: "Acqua naturale o frizzante a volontà. Un prezzo unico per tutta l'acqua che desideri." },
        ],
      },
      examples: {
        title: 'Esempi di Pasto',
        total: 'Totale',
        meals: [
          {
            title: 'Pranzo Veloce',
            items: ['Primo piatto (150g)', 'Contorno (100g)'],
            prices: ['6,60\u20AC', '2,20\u20AC'],
            total: '8,75\u20AC',
          },
          {
            title: 'Pranzo Completo',
            items: ['Primo piatto (200g)', 'Secondo (150g)', 'Contorno (100g)'],
            prices: ['4,40\u20AC', '3,30\u20AC', '2,20\u20AC'],
            total: '15,75\u20AC',
          },
          {
            title: 'Pranzo con Dolce',
            items: ['Primo (200g)', 'Secondo (200g)', 'Dolce (100g)'],
            prices: ['4,40\u20AC', '4,40\u20AC', '2,00\u20AC'],
            total: '17,50\u20AC',
          },
        ],
      },
    },
    doveSiamoPage: {
      hero: {
        title: 'Dove Siamo',
        subtitle: 'Nel cuore di Bologna',
      },
      labels: {
        lunch: 'Pranzo',
      },
      contact: {
        title: 'Contattaci',
        items: [
          { title: 'Indirizzo', info: 'Via Jacopo della Quercia 2/2D, Bologna' },
        ],
      },
      bologna: {
        title: 'Bologna, la Rossa',
        subtitle: "Nel cuore della città più golosa d'Italia",
      },
    },
    newsPage: {
      hero: {
        title: 'News & Eventi',
        subtitle: 'Scopri le ultime novità da Lola',
      },
      featured: 'In Evidenza',
      readMore: 'Leggi di più',
      allNews: 'Tutte le News',
      categories: ['Tutti', 'Evento', 'Promozione', 'Menu', 'Business'],
      newsletter: {
        title: 'Resta Aggiornato',
        text: 'Iscriviti alla nostra newsletter per ricevere novità, eventi e promozioni esclusive',
        placeholder: 'La tua email',
        button: 'Iscriviti',
      },
      upcoming: {
        label: 'Prossimo evento:',
        event: 'Serata Degustazione Vini',
        date: '28 Febbraio 2026',
        cta: 'Prenota ora',
      },
      items: [
        {
          id: 1,
          title: 'Inaugurazione Lola la Libertà!',
          date: '15 Gennaio 2026',
          category: 'Evento',
          excerpt: "Siamo entusiasti di annunciare l'apertura del primo buffet a peso di Bologna. Vieni a scoprire il nostro concept unico!",
          featured: true,
        },
        {
          id: 2,
          title: 'Menu Speciale di Carnevale',
          date: '20 Febbraio 2026',
          category: 'Promozione',
          excerpt: 'Dolci tradizionali del Carnevale: frappe, castagnole e tortelli alla crema disponibili per tutto il periodo!',
          featured: false,
        },
        {
          id: 3,
          title: 'Serata Degustazione Vini Emiliani',
          date: '28 Febbraio 2026',
          category: 'Evento',
          excerpt: 'Una serata speciale dedicata ai vini del territorio: Lambrusco, Pignoletto e Sangiovese in abbinamento ai nostri piatti.',
          featured: false,
        },
        {
          id: 4,
          title: 'Nuovi Piatti Primaverili',
          date: '1 Marzo 2026',
          category: 'Menu',
          excerpt: 'Con l\'arrivo della primavera, il nostro buffet si arricchisce di nuove verdure di stagione e ricette leggere.',
          featured: false,
        },
        {
          id: 5,
          title: 'Convenzione Aziende',
          date: '10 Marzo 2026',
          category: 'Business',
          excerpt: 'Scopri la nostra convenzione per aziende: prezzi dedicati e servizio veloce per la pausa pranzo dei tuoi dipendenti.',
          featured: false,
        },
        {
          id: 6,
          title: 'Pasqua da Lola',
          date: '20 Aprile 2026',
          category: 'Evento',
          excerpt: 'Menu speciale pasquale con i piatti della tradizione emiliana: lasagne, tortellini in brodo e colomba artigianale.',
          featured: false,
        },
      ],
    },
  },
  en: {
    nav: {
      comeFunziona: 'How It Works',
      menu: 'The Menu',
      prezzo: 'Pricing',
      doveSiamo: 'Find Us',
      chiSiamo: 'About Us',
    },
    hero: {
      badge: 'AUTHENTIC ITALIAN CUISINE',
      title: 'The Only Pay-by-Weight Buffet in Bologna',
      subtitle: 'Free, Authentic, Fast.',
      description: 'Italian cuisine from a controlled supply chain. Build your plate, place it on the scale, and pay only for what you choose \u2014 at your own pace.',
      priceLabel: '/100g',
      scrollText: 'Discover more',
    },
    stats: {
      pricePerHecto: 'PER 100G',
      minConsumption: 'MINIMUM',
      freshDishes: 'FRESH DISHES',
      italianRecipes: 'ITALIAN RECIPES',
    },
    concept: {
      overline: 'OUR CONCEPT',
      title: 'Where Freedom Meets Flavour',
      text1: 'If you are wondering where to eat in Bologna for an experience unlike any other, welcome to our contemporary bistro. Here the customer takes centre stage: build your ideal plate from a rich gourmet buffet that celebrates the flavours of regional and national tradition.',
      text2: 'We are the first pay-by-weight restaurant in Bologna, designed for those who love flexibility: choose only what you want and pay exactly for what you eat.',
      text3: 'Every recipe is the result of constant research to guarantee a restaurant with a controlled supply chain, where seasonality and the excellence of Italian cuisine always come first. It is not just about eating healthy, but about rediscovering the mindful pleasure of an authentic, everyday meal.',
      highlight: 'It is a format that celebrates simplicity \u2014 the freedom to choose, trust in food, the joy of shared flavour.',
    },
    vision: {
      overline: 'OUR VISION',
      title: 'Inspiring a New Way to Eat',
      text: 'To become a reference point for anyone seeking a lunch break in Bologna that makes no compromises between speed and well-being. We want to inspire a new way of eating Italian \u2014 free, mindful and joyful \u2014 where every choice tells a simple yet meaningful story of respect for the land and pleasure in everyday life.',
      values: [
        { title: 'Freedom', desc: 'You choose what and how much to eat' },
        { title: 'Authenticity', desc: 'Recipes rooted in Italian tradition' },
        { title: 'Mindfulness', desc: 'Fresh, transparent ingredients' },
      ],
    },
    mission: {
      overline: 'OUR MISSION',
      title: 'Nurturing the Pleasure of Choice',
      text1: 'We want to restore food to its deepest power: to nourish and move people \u2014 without pretence.',
      text2: 'Our bistro is a free space where everyone composes their own experience as an act of love towards life and themselves.',
      text3: 'Every dish is an encounter between Italian tradition and personal freedom, an act of curiosity and exploration.',
      highlight: 'We believe happiness also passes through here \u2014 a simple meal, done well, shared with loved ones or with yourself. Every single day.',
    },
    howItWorks: {
      overline: 'OUR SYSTEM',
      title: 'How It Works',
      steps: [
        {
          title: 'Take Your Seat',
          subtitle: 'WITH THE TABLE TOKEN',
          description: 'Claim your table with the token. Our warm atmosphere awaits you.',
        },
        {
          title: 'Build Your Plate',
          subtitle: 'AT THE BUFFET',
          description: 'Head to the buffet and freely compose your plate with our Italian recipes.',
        },
        {
          title: 'Weigh at the Counter',
          subtitle: 'AT THE CHECKOUT',
          description: 'Bring your plate to the counter: we weigh it for you. Just \u20AC2.20 per 100 g.',
        },
        {
          title: 'Savour the Freedom',
          subtitle: 'ENJOY YOUR MEAL',
          description: 'Sit down, eat and enjoy authentic Italian cuisine. You can go back as many times as you like!',
        },
      ],
    },
    moments: {
      lunch: {
        title: 'Lunch Break in Bologna? Quick, healthy, and tailored to you.',
        description: 'Forget the long waits of table service. At Lola la Libertà you run your own break: grab a tray, choose from dozens of fresh recipes (lasagne, seasonal vegetables and tempting mains), weigh your plate and sit down. All the quality of a real Italian restaurant, with the speed and ease you need to enjoy your meal and head back to work satisfied.',
      },
    },
    menu: {
      overline: 'TRADITIONAL RECIPES',
      title: 'A Taste of What We Cook',
      subtitle: 'Every day we prepare over 20 fresh dishes with carefully selected ingredients.',
      tabs: {
        primi: 'First Courses',
        secondi: 'Main Courses',
        contorni: 'Side Dishes',
        dolci: 'Desserts',
      },
      items: {
        primi: [
          'Lasagne Bolognese',
          'Tagliatelle with ragu',
          'Tortellini in broth',
          'Risotto alla Parmigiana',
          'Pasta e fagioli',
          'Ricotta & spinach cannelloni',
        ],
        secondi: [
          'Herb-roasted chicken',
          'Milanese cutlet',
          'Meatballs in tomato sauce',
          'Roast pork',
          'Lemon scaloppine',
          'Vicentina-style salt cod',
        ],
        contorni: [
          'Roast potatoes',
          'Grilled vegetables',
          'Mixed salad',
          'Sauteed spinach',
          'Sicilian caponata',
          'Green beans in tomato',
        ],
        dolci: [
          'House tiramisu',
          'Panna cotta',
          'Grandmother\'s cake',
          'Crema catalana',
          'Fruit tart',
          'Sicilian cannoli',
        ],
      },
    },
    pricing: {
      overline: 'TOTAL TRANSPARENCY',
      title: 'One Price,',
      titleItalic: 'No Surprises',
      description: 'You pay exactly what you eat: simply the weight of your plate multiplied by \u20AC2.20 per 100 g.',
      card: {
        label: 'SINGLE PRICE',
        unit: 'per 100g',
        min: '',
        exampleTitle: 'MEAL EXAMPLE',
        example: {
          primo: 'First course (200g)',
          secondo: 'Main course (150g)',
          contorno: 'Side dish (100g)',
          total: 'Total',
        },
      },
      features: [
        { title: 'Free Cover', desc: 'No service charge at all' },
        { title: 'Free Water', desc: 'Drink as much as you like' },
        { title: 'Unlimited Portions', desc: 'Take what you want, come back as often as you like' },
      ],
    },
    location: {
      overline: 'COME VISIT US',
      title: 'Find Us',
      address: 'Via Jacopo della Quercia 2/2D',
      city: '40128 Bologna (BO)',
      openMaps: 'Open in Google Maps',
      info: {
        hours: {
          title: 'Opening Hours',
          weekdays: 'Monday \u2013 Friday',
          lunch: '12:00 \u2013 15:00',
        },
        address: {
          title: 'Address',
        },
        parking: {
          title: 'Parking',
          line1: 'Blue-line street parking available',
          line2: 'Pay-and-display',
        },
        price: {
          title: 'Price',
          line1: '\u20AC2.20 per 100g',
          line2: 'Free cover',
          line3: 'Free water',
        },
      },
    },
    footer: {
      tagline: 'Where freedom meets flavour.',
      description: 'The first pay-by-weight buffet in Bologna. Authentic Italian cuisine, fresh ingredients, transparent prices.',
      navigation: 'Navigation',
      contact: 'Contact',
      social: 'Social',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms & Conditions',
      rights: 'All rights reserved.',
    },
    booking: {
      button: 'Book now!',
    },
    // Page-specific translations
    home: {
      explore: {
        title: 'Explore Lola la Libertà',
      },
      sections: [
        { title: 'About Us', desc: 'Discover our philosophy and bistro concept', discoverMore: 'Learn more' },
        { title: 'How It Works', desc: 'Our unique system in 4 simple steps', discoverMore: 'Learn more' },
        { title: 'The Menu', desc: 'Explore our traditional Italian dishes', discoverMore: 'Learn more' },
        { title: 'Pricing', desc: 'Total transparency: \u20AC2.20 per 100 g', discoverMore: 'Learn more' },
        { title: 'Find Us', desc: 'Visit us in the heart of Bologna', discoverMore: 'Learn more' },
        { title: 'News', desc: 'Events, updates and promotions', discoverMore: 'Learn more' },
      ],
      quickInfo: [
        'Via Jacopo della Quercia 2/2D, Bologna',
        'Mon\u2013Fri: 12:00\u201315:00',
        '\u20AC2.20 per 100g',
        '20+ fresh dishes every day',
      ],
    },
    chiSiamoPage: {
      hero: {
        title: 'About Us \u2013 Lola la Libertà, Your Contemporary Bistro in Bologna',
        subtitle: 'Where quality meets the freedom of choice.',
      },
      values: {
        title: 'Our Values',
        items: [
          { title: 'Freedom', desc: 'You choose what and how much to eat, with no constraints' },
          { title: 'Quality', desc: 'Fresh ingredients from controlled supply chains' },
          { title: 'Conviviality', desc: 'A place to share the pleasure of food' },
          { title: 'Authenticity', desc: 'Recipes rooted in Italian tradition' },
        ],
      },
    },
    comeFunzionaPage: {
      hero: {
        title: 'How It Works',
        subtitle: 'Our unique system in 4 simple steps',
      },
      whyChoose: {
        title: 'Why Choose Lola',
      },
      features: [
        { title: 'Fast', desc: 'Lunch break in 30 minutes, no waiting' },
        { title: 'Transparent', desc: 'Pay only for what you eat, by weight' },
        { title: 'Variety', desc: 'Over 30 fresh dishes every day' },
        { title: 'Quality', desc: 'Selected ingredients from Italian supply chains' },
        { title: 'Flexible', desc: 'Go back to the buffet as often as you like' },
        { title: 'Convenient', desc: 'In the heart of Bologna, easy to reach' },
      ],
    },
    menuPage: {
      hero: {
        title: 'The Menu',
        subtitle: 'Traditional Bolognese and Italian recipes',
      },
      intro: 'Every day we prepare over <strong>20 fresh dishes</strong> with ingredients sourced from controlled supply chains. From lasagne Bolognese to tortellini in broth, from hearty mains to seasonal vegetables: build your plate just the way you like it.',
      gallery: {
        title: 'Our Dishes',
      },
      seasonalNote: 'The menu changes daily based on seasonal availability',
    },
    prezzoPage: {
      hero: {
        title: 'Pricing',
        subtitle: 'Total transparency, no surprises',
      },
      howPricing: {
        title: 'How Pricing Works',
        items: [
          { title: '\u20AC2.20/100g', desc: 'Buffet food is weighed and charged by weight. Take what you want, pay only for what you eat.' },
          { title: '\u20AC0.50 cover', desc: 'The cover charge includes napkins, cutlery and table service. A fixed price for everyone.' },
          { title: '\u20AC0.50 water', desc: 'Still or sparkling water, unlimited. One price for all the water you want.' },
        ],
      },
      examples: {
        title: 'Meal Examples',
        total: 'Total',
        meals: [
          {
            title: 'Quick Lunch',
            items: ['First course (150g)', 'Side dish (100g)'],
            prices: ['\u20AC6.60', '\u20AC2.20'],
            total: '\u20AC8.75',
          },
          {
            title: 'Full Lunch',
            items: ['First course (200g)', 'Main course (150g)', 'Side dish (100g)'],
            prices: ['\u20AC4.40', '\u20AC3.30', '\u20AC2.20'],
            total: '\u20AC15.75',
          },
          {
            title: 'Lunch with Dessert',
            items: ['First course (200g)', 'Main course (200g)', 'Dessert (100g)'],
            prices: ['\u20AC4.40', '\u20AC4.40', '\u20AC2.00'],
            total: '\u20AC17.50',
          },
        ],
      },
    },
    doveSiamoPage: {
      hero: {
        title: 'Find Us',
        subtitle: 'In the heart of Bologna',
      },
      labels: {
        lunch: 'Lunch',
      },
      contact: {
        title: 'Get in Touch',
        items: [
          { title: 'Address', info: 'Via Jacopo della Quercia 2/2D, Bologna' },
        ],
      },
      bologna: {
        title: 'Bologna, the Red City',
        subtitle: 'In the heart of Italy\'s most food-loving city',
      },
    },
    newsPage: {
      hero: {
        title: 'News & Events',
        subtitle: 'Discover the latest from Lola',
      },
      featured: 'Featured',
      readMore: 'Read more',
      allNews: 'All News',
      categories: ['All', 'Event', 'Promotion', 'Menu', 'Business'],
      newsletter: {
        title: 'Stay Updated',
        text: 'Subscribe to our newsletter to receive news, events and exclusive promotions',
        placeholder: 'Your email',
        button: 'Subscribe',
      },
      upcoming: {
        label: 'Next event:',
        event: 'Emilian Wine Tasting Evening',
        date: '28 February 2026',
        cta: 'Book now',
      },
      items: [
        {
          id: 1,
          title: 'Grand Opening of Lola la Libertà!',
          date: '15 January 2026',
          category: 'Event',
          excerpt: 'We are thrilled to announce the opening of the first pay-by-weight buffet in Bologna. Come and discover our unique concept!',
          featured: true,
        },
        {
          id: 2,
          title: 'Special Carnival Menu',
          date: '20 February 2026',
          category: 'Promotion',
          excerpt: 'Traditional Carnival sweets: frappe, castagnole and cream-filled tortelli available throughout the season!',
          featured: false,
        },
        {
          id: 3,
          title: 'Emilian Wine Tasting Evening',
          date: '28 February 2026',
          category: 'Event',
          excerpt: 'A special evening dedicated to local wines: Lambrusco, Pignoletto and Sangiovese paired with our dishes.',
          featured: false,
        },
        {
          id: 4,
          title: 'New Spring Dishes',
          date: '1 March 2026',
          category: 'Menu',
          excerpt: 'With spring arriving, our buffet welcomes new seasonal vegetables and lighter recipes.',
          featured: false,
        },
        {
          id: 5,
          title: 'Corporate Partnership',
          date: '10 March 2026',
          category: 'Business',
          excerpt: 'Discover our corporate deals: dedicated pricing and fast service for your employees\' lunch break.',
          featured: false,
        },
        {
          id: 6,
          title: 'Easter at Lola',
          date: '20 April 2026',
          category: 'Event',
          excerpt: 'Special Easter menu featuring traditional Emilian dishes: lasagne, tortellini in broth and artisan colomba cake.',
          featured: false,
        },
      ],
    },
  },
};
